import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { orchestration } from '~/config/public';
import { Session } from '~/App/shared/interfaces/store/Session';

export const resetPassword = (email: string) =>
  axios.post<undefined>(
    `${orchestration.url}/common/members/reset-password`,
    {
      email
    },
    {
      responseType: 'json'
    }
  );

type ResetPasswordSubmit = {
  token: string;
  newPassword: string;
  termsAccepted?: boolean;
};
export const resetPasswordSubmit = ({
  token,
  newPassword,
  termsAccepted
}: ResetPasswordSubmit) =>
  axios.post<Session>(
    `${orchestration.url}/common/members/reset-password/submit`,
    {
      token: token || '',
      newPassword: newPassword || '',
      ...(termsAccepted ? { termsAccepted: termsAccepted } : {})
    },
    {
      responseType: 'json'
    }
  );

interface ValidateResetPasswordTokenResponse {
  isValidToken: boolean;
}
export const validateResetPasswordToken = (token: string) =>
  axios.post<ValidateResetPasswordTokenResponse>(
    `${orchestration.url}/common/members/reset-password/validate`,
    {
      token
    },
    {
      responseType: 'json'
    }
  );

type ChangePasswordArgs = {
  idToken: string;
  changePassword: {
    newPassword: string;
    currentPassword: string;
    confirmPassword: string;
  };
};
export const changePassword = ({
  changePassword,
  idToken: _idToken
}: ChangePasswordArgs) =>
  axios.post<Session>(
    `${orchestration.url}/common/members/me/change-password`,
    { changePassword: changePassword || {} },
    {
      withCredentials: true,
      responseType: 'json'
    }
  );
